module.exports = __webpack_public_path__ + "media/images/background_solutions-520w-370c47ec.jpg";